"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[419],{

/***/ 8029:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/list-icon-straight-arrow-primary.0abd4f6b.svg","height":9,"width":9});

/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/list-icon.70325e21.svg","height":15,"width":23});

/***/ }),

/***/ 4169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _apis_queryFunctions_pageInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1223);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6646);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9469);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var public_icons_backarrow_png__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9802);
/* harmony import */ var public_images_logo_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(846);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7294);
/* harmony import */ var _Download_AppStore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6324);
/* harmony import */ var _Download_ChPlay__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3048);











function AppDownload() {
    var ref, ref1;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var data = (0,_apis_queryFunctions_pageInfo__WEBPACK_IMPORTED_MODULE_1__/* .useFetchPageInfo */ .u$)("web-home-download").data;
    var imgQrCode = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pictures) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
        return x.picture_id === "qr-code";
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.picture_url;
    var label = {
        vi: {
            text: "Qu\xe9t m\xe3 tải App"
        },
        en: {
            text: "Scan QR Code"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            maxWidth: 465
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                marginTop: 13
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .SimpleGrid */ .M, {
                cols: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Download_AppStore__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        width: 226,
                        height: 66
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Download_ChPlay__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        width: 226,
                        height: 66
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppDownload);


/***/ }),

/***/ 1425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_getFieldFromFieldId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7662);
/* harmony import */ var _utils_sanitizeDOMData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2559);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8949);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var public_icons_list_icon_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9881);
/* harmony import */ var _Heading_BannerHeading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2727);








function BannerTextContent(param) {
    var data = param.data, children = param.children;
    var ref;
    var title = (0,_utils_getFieldFromFieldId__WEBPACK_IMPORTED_MODULE_5__/* .getFieldFromFieldId */ .Z)("title", "content_id", data);
    var detail = (0,_utils_getFieldFromFieldId__WEBPACK_IMPORTED_MODULE_5__/* .getFieldFromFieldId */ .Z)("detail", "content_id", data);
    var list = (0,_utils_getFieldFromFieldId__WEBPACK_IMPORTED_MODULE_5__/* .getFieldFromFieldId */ .Z)("list-item", "content_id", data);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        sx: {},
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading_BannerHeading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: (0,_utils_sanitizeDOMData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((title === null || title === void 0 ? void 0 : title.content_editor) || (title === null || title === void 0 ? void 0 : title.content))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                weight: 400,
                mt: 14,
                mb: 8,
                sx: function(theme) {
                    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        fontSize: 20,
                        fontStyle: "normal"
                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                        fontSize: 20
                    });
                },
                children: detail === null || detail === void 0 ? void 0 : detail.content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .List */ .a, {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    sx: {
                        width: 23,
                        height: 23,
                        marginRight: 14
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: public_icons_list_icon_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                        alt: "vector Top right",
                        width: 23,
                        height: 23
                    })
                }),
                sx: function(theme) {
                    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        fontSize: 20,
                        color: theme.colors.neutral[0]
                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                        fontSize: 18
                    });
                },
                styles: {
                    itemWrapper: {
                        alignItems: "center !important"
                    }
                },
                mb: 16,
                children: (ref = list === null || list === void 0 ? void 0 : list.sort(function(a, b) {
                    return (a === null || a === void 0 ? void 0 : a.stt) - (b === null || b === void 0 ? void 0 : b.stt);
                })) === null || ref === void 0 ? void 0 : ref.map(function(item, k) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .List.Item */ .a.Item, {
                        children: item.content
                    }, k);
                })
            }),
            children
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BannerTextContent);


/***/ }),

/***/ 753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(8623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(3284);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(5117);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./public/icons/vector_breadcrumbs.png
/* harmony default export */ var vector_breadcrumbs = ({"src":"/_next/static/media/vector_breadcrumbs.238a2498.png","height":75,"width":75,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAACpf3wfAAAAB3RSTlMAoQtQrjwkp+/75AAAAAlwSFlzAAAhOAAAITgBRZYxYAAAABpJREFUCJljYGBjZGKAAFYWPCxmRuw0G4QGAApUAD5UPdIXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./common/components/Breadcrumbs.js






var AppBreadcrumbs = function(param) {
    var items = param.items, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
            separator: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: vector_breadcrumbs,
                alt: "vector",
                width: 10,
                height: 12
            }),
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: item.href || "#",
                    scroll: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "#000",
                            size: "xs",
                            lineClamp: index === items.length - 1 ? 1 : 2,
                            sx: {
                                width: index === items.length - 1 ? "fit-content" : "max-content"
                            },
                            weight: index === items.length - 1 ? 600 : 400,
                            children: item.title
                        })
                    })
                }, index);
            })
        })
    });
};
AppBreadcrumbs.propTypes = {
    items: (prop_types_default()).array.isRequired
};
/* harmony default export */ var components_Breadcrumbs = (AppBreadcrumbs);


/***/ }),

/***/ 2727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _TextSSR__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7319);





function BannerHeading(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextSSR__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        type: "title",
        order: 1,
        weight: 700,
        size: 32,
        md: {
            text: {
                fontSize: 40
            }
        },
        children: children
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (BannerHeading);


/***/ }),

/***/ 7217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _TextSSR__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7319);


function SectionHeading(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextSSR__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        type: "title",
        size: "h2",
        order: 2,
        align: "center",
        containerProps: {
            mb: 19
        },
        md: {
            text: {
                fontSize: 32
            },
            container: {
                marginBottom: 31
            }
        },
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeading);


/***/ }),

/***/ 3617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomeDownload; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _apis_queryFunctions_pageInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1223);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6646);
/* harmony import */ var _utils_sanitizeDOMData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2559);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9094);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var _AppDownload__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4169);
/* harmony import */ var _HomeTitle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9936);
/* harmony import */ var _Line__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8611);














function HomeDownload(param) {
    var _data = param.data, style = param.style;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)().locale;
    var data = (0,_apis_queryFunctions_pageInfo__WEBPACK_IMPORTED_MODULE_1__/* .useFetchPageInfo */ .u$)("web-home-download", {
        condition: {
            ngon_ngu: locale
        }
    }, _data).data;
    var title = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.text_field) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
        return x.content_id === "title";
    })[0]) === null || ref1 === void 0 ? void 0 : ref1.content_editor;
    var imgAppView = (ref3 = data === null || data === void 0 ? void 0 : (ref2 = data.pictures) === null || ref2 === void 0 ? void 0 : ref2.filter(function(x) {
        return x.picture_id === "app-view";
    })[0]) === null || ref3 === void 0 ? void 0 : ref3.picture_url;
    var imgBg = (ref5 = data === null || data === void 0 ? void 0 : (ref4 = data.pictures) === null || ref4 === void 0 ? void 0 : ref4.filter(function(x) {
        return x.picture_id === "app-view-background";
    })[0]) === null || ref5 === void 0 ? void 0 : ref5.picture_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
        sx: function(theme) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                width: "100%",
                paddingBottom: 80
            }, style), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                paddingBottom: 40
            }, style === null || style === void 0 ? void 0 : style["@media (max-width: ".concat(theme.breakpoints.md, "px)")])));
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Line__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                index: 1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_14__/* .Center */ .M, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HomeTitle__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    style: {
                        maxWidth: 546,
                        textAlign: "center"
                    },
                    children: (0,_utils_sanitizeDOMData__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(title)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Grid */ .r, {
                gutter: 0,
                align: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Grid.Col */ .r.Col, {
                        xs: 12,
                        md: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppDownload__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_15__/* .Grid.Col */ .r.Col, {
                        xs: 12,
                        md: 6,
                        sx: function(theme) {
                            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, theme.fn.smallerThan("md"), {
                                marginTop: 59
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            style: {
                                width: "100%",
                                height: "100%",
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                        src: imgBg
                                    }),
                                    layout: "fill",
                                    alt: "bg",
                                    objectFit: "contain",
                                    //placeholder="blur"
                                    blurDataURL: "https://via.placeholder.com/521x502"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, {
                                    sx: {
                                        transition: "0.6s",
                                        textAlign: "center",
                                        "&:hover": {
                                            // animation: "slideUpDown ease-in-out 2s infinite",
                                            transform: "translateY(-40px)"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                            src: imgAppView,
                                            size: "xl"
                                        }),
                                        alt: "app",
                                        width: 521,
                                        height: 502,
                                        objectFit: "contain",
                                        quality: 100,
                                        layout: "intrinsic",
                                        //placeholder="blur"
                                        blurDataURL: "https://via.placeholder.com/521x502",
                                        style: {
                                            transform: "scale(0.9)"
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 9936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomeTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9236);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);







function HomeTitle(_param) {
    var children = _param.children, style = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .D, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        weight: 400,
        order: 2,
        color: "#001529",
        sx: function(theme) {
            return(// marginTop: 0,
            (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                // textAlign: "left",
                fontSize: 34,
                marginBottom: 40,
                fontWeight: "400"
            }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                textAlign: "center",
                fontSize: 22,
                marginBottom: 16
            }));
        }
    }, style), {
        children: children
    }));
};


/***/ }),

/***/ 806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6646);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9236);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8949);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var public_icons_list_icon_straight_arrow_primary_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8029);






function InvestmentInfoCard(param) {
    var _title = param.title, title = _title === void 0 ? "" : _title, _iconUrl = param.iconUrl, iconUrl = _iconUrl === void 0 ? "" : _iconUrl, _list = param.list, list = _list === void 0 ? [] : _list;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        px: 36,
        py: 36,
        sx: function(theme) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                border: "1px solid ".concat(theme.colors.neutral[5]),
                borderRadius: 13,
                height: "100%",
                transition: "all 0.4s ease"
            }, "&:hover", {
                transform: "translateY(-18px)",
                boxShadow: "20px 20px 40px rgba(43, 223, 206, 0.3)"
            });
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                sx: function() {
                    return {
                        width: 53,
                        height: 53,
                        // padding: 10,
                        // backgroundColor: theme.colors.main[5],
                        // borderRadius: 7,
                        position: "relative"
                    };
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                        src: iconUrl,
                        size: "s"
                    }),
                    layout: "responsive",
                    alt: "Icon",
                    width: 53,
                    height: 53
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Title */ .D, {
                mb: 12,
                mt: 16,
                order: 4,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .List */ .a, {
                    listStyleType: "none",
                    children: (ref = list === null || list === void 0 ? void 0 : list.filter(function(el) {
                        return el.content_id === "list-item";
                    })) === null || ref === void 0 ? void 0 : ref.map(function(el, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .List.Item */ .a.Item, {
                            icon: index !== 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                                sx: {
                                    width: 16,
                                    height: 16,
                                    marginRight: 4,
                                    marginLeft: 2
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: public_icons_list_icon_straight_arrow_primary_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                    alt: "vector Top right",
                                    width: 14,
                                    height: 14
                                })
                            }),
                            mb: 7,
                            children: el.content
                        }, index);
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InvestmentInfoCard);


/***/ }),

/***/ 8611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Line; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-media-query/use-media-query.js
var use_media_query = __webpack_require__(4065);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/icons/line_1.png
/* harmony default export */ var line_1 = ({"src":"/_next/static/media/line_1.5cb1d169.png","height":93,"width":552,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAADFBMVEUWoZoWpJsXqqEBHC+xUzMuAAAABHRSTlMSL1Cbp/TvywAAAAlwSFlzAAAhOAAAITgBRZYxYAAAABFJREFUCJljYGBkYmZmYmQAAAA/AA1NtdOjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/icons/line_2.png
/* harmony default export */ var line_2 = ({"src":"/_next/static/media/line_2.0664e61b.png","height":93,"width":552,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEUAEycVi4cOhPWCAAAAAnRSTlMOCZHMWBIAAAAJcEhZcwAAITgAACE4AUWWMWAAAAARSURBVAiZY2BkZGBgYGBkBAAAGwAFQ08qXAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./public/icons/line_3.png
/* harmony default export */ var line_3 = ({"src":"/_next/static/media/line_3.2e230008.png","height":93,"width":552,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAACVBMVEVMaXEYmpQcrqX7ayx8AAAAA3RSTlMAEEW2AmOQAAAACXBIWXMAACE4AAAhOAFFljFgAAAAEUlEQVQImWNgYGBkYmJkYAAAACQABzCHW/IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":1});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./common/components/Line.js









function Line(param) {
    var _index = param.index, index = _index === void 0 ? 0 : _index;
    var isMobile = (0,use_media_query/* useMediaQuery */.a)("(max-width: 992px)");
    var list = [
        {
            src: line_1,
            width: 388,
            height: 38,
            mWidth: 184,
            mHeight: 31
        },
        {
            src: line_2,
            width: 388,
            height: 38,
            mWidth: 184,
            mHeight: 31
        },
        {
            src: line_3,
            width: 388,
            height: 65,
            mWidth: 184,
            mHeight: 31
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
        sx: function(theme) {
            return (0,_define_property/* default */.Z)({
                margin: "60px auto 30px"
            }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                margin: "24px auto"
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            sx: function(theme) {
                return (0,_define_property/* default */.Z)({
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                    position: "relative",
                    width: list[index].width,
                    height: list[index].height
                }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                    width: list[index].mWidth,
                    height: list[index].mHeight
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: list[index].src,
                alt: "line",
                width: isMobile ? list[index].mWidth : list[index].width,
                height: isMobile ? list[index].mHeight : list[index].height,
                // layout="fill"
                objectFit: "fill"
            })
        })
    });
};


/***/ }),

/***/ 7319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5117);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9236);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);







function TextSSR(_param) {
    var _type = _param.type, type = _type === void 0 ? "text" : _type, _containerStyle = _param.containerStyle, containerStyle = _containerStyle === void 0 ? {} : _containerStyle, _containerProps = _param.containerProps, containerProps = _containerProps === void 0 ? {} : _containerProps, _xs = _param.xs, xs = _xs === void 0 ? {} : _xs, _sm = _param.sm, sm = _sm === void 0 ? {} : _sm, _md = _param.md, md = _md === void 0 ? {} : _md, _lg = _param.lg, lg = _lg === void 0 ? {} : _lg, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "type",
        "containerStyle",
        "containerProps",
        "xs",
        "sm",
        "md",
        "lg",
        "children"
    ]);
    var isTitle = props.size === "h1" || props.size === "h2" || props.size === "h3" || props.size === "h4" || props.size === "h5" || props.size === "h6" || props.order;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, containerProps), {
        sx: function(theme) {
            var _obj;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, containerStyle), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.smallerThan("xs"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, xs.container)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("sm"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sm.container)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("md"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, md.container)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("lg"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, lg.container)), _obj));
        },
        children: [
            type === "text" && !isTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                weight: 400
            }, props), {
                sx: function(theme) {
                    var _obj;
                    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.smallerThan("sm"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, xs.text)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("sm"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sm.text)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("md"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, md.text)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("lg"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, lg.text)), _obj;
                },
                children: children
            })),
            (type === "title" || isTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_7__/* .Title */ .D, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                weight: 400
            }, props), {
                sx: function(theme) {
                    var _obj;
                    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.smallerThan("sm"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, xs.text)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("sm"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, sm.text)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("md"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, md.text)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_obj, theme.fn.largerThan("lg"), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, lg.text)), _obj;
                },
                children: children
            }))
        ]
    }));
}
TextSSR.propTypes = {
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (TextSSR);


/***/ }),

/***/ 2989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _apis_queryFunctions_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7860);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6646);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7414);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8090);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);








function Video(param) {
    var video_url = param.video_url, placeholderImageUrl = param.placeholderImageUrl;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_4__.useState(), 2), isVideoOpen = ref[0], setIsVideoOpen = ref[1];
    var hasVideo = !!video_url;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                sx: function(theme) {
                    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        width: "85%",
                        height: "85%",
                        border: "3px solid ".concat(theme.colors.main[2]),
                        borderRadius: "56px",
                        position: "absolute",
                        bottom: "4%",
                        right: "-1%"
                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                        borderRadius: "16px"
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                sx: function(theme) {
                    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        boxShadow: "20px 20px 40px rgba(43, 223, 206, 0.3)",
                        width: "90%",
                        height: "90%",
                        position: "relative",
                        borderRadius: "56px",
                        overflow: "hidden"
                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                        borderRadius: "16px"
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                        src: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                            src: placeholderImageUrl
                        }),
                        alt: "image placeholder for video",
                        layout: "fill",
                        objectFit: "cover",
                        priority: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 10
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                            sx: function(theme) {
                                return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                    width: 104,
                                    height: 104,
                                    background: theme.colors.accent[19],
                                    borderRadius: "50%",
                                    position: "relative",
                                    cursor: "pointer"
                                }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                    width: 53,
                                    height: 53
                                });
                            },
                            onClick: function() {
                                setIsVideoOpen(true);
                                (0,_apis_queryFunctions_tracking__WEBPACK_IMPORTED_MODULE_1__/* .addtrackingEvent */ .sm)({
                                    vi_tri: _apis_queryFunctions_tracking__WEBPACK_IMPORTED_MODULE_1__/* .TRACKING_VI_TRI.BDS */ .QK.BDS,
                                    field_id: _apis_queryFunctions_tracking__WEBPACK_IMPORTED_MODULE_1__/* .TRACKING_NAMES.BDS_play */ .BK.BDS_play
                                });
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                                sx: function(theme) {
                                    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 0,
                                        height: 0,
                                        borderTop: "15px solid transparent",
                                        borderBottom: "15px solid transparent",
                                        borderLeft: "28px solid ".concat(theme.colors.main[0]),
                                        borderRadius: "4px"
                                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                        borderTop: "8px solid transparent",
                                        borderBottom: "8px solid transparent",
                                        borderLeft: "14px solid ".concat(theme.colors.main[0])
                                    });
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_8__/* .Modal */ .u, {
                opened: isVideoOpen && hasVideo,
                onClose: function() {
                    return setIsVideoOpen(false);
                },
                padding: 0,
                size: "78%",
                styles: function(theme) {
                    return {
                        header: {
                            display: "none"
                        },
                        body: {
                            display: "flex",
                            aspectRatio: "1.77",
                            width: "100%"
                        },
                        modal: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                            width: "100%"
                        })
                    };
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                    width: "100%",
                    height: "100%",
                    src: "".concat(video_url),
                    frameBorder: "0",
                    title: "",
                    allow: "autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowFullScreen: true,
                    autoPlay: true
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Video);


/***/ }),

/***/ 7662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFieldFromFieldId; }
/* harmony export */ });
function getFieldFromFieldId(fieldId) {
    var fieldName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "content_id", fields = arguments.length > 2 ? arguments[2] : void 0, shared = arguments.length > 3 ? arguments[3] : void 0;
    if (!fieldId || !fields || (fields === null || fields === void 0 ? void 0 : fields.length) === 0) return null;
    var matches = fields.filter(function(el) {
        return shared ? el[fieldName] === fieldId && el.shared === true : el[fieldName] === fieldId;
    });
    if (matches && matches.length === 0) return [];
    if (matches && matches.length === 1) return matches[0];
    if (matches && matches.length > 1) return matches;
    return {};
}


/***/ })

}]);